import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { AccordionPanel } from 'reaxl';
import { FilterCheckboxes } from 'reaxl-filters';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterPlaceholder from './FilterPlaceholder';

function DriveTypeFilter({
    onOptionChange = () => { },
    onOptionsClear = () => { },
    handleShowExpansion = () => { },
}) {
    const driveTypeValues = useSelector(srpFiltersDuck.selectors.getDriveTypeValues);
    const driveTypeOptions = useSelector(srpFiltersDuck.selectors.getDriveTypeOptions);
    const filtersErrors = useSelector(srpFiltersDuck.selectors.getFiltersErrors);

    const filterValues = { driveGroup: driveTypeValues };

    const filterName = 'driveGroup';
    const isExpanded = useSelector((state) => srpFiltersDuck.selectors.isExpansionActive(state, filterName));
    const showFilter = isExpanded && Object.keys(driveTypeOptions).length !== 0;

    const title = getFilterTitle('Drive Type', driveTypeValues);

    // expand the panel if active options inside of it
    useEffect(() => {
        if (driveTypeValues.length) {
            handleShowExpansion(filterName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [driveTypeValues.length]);

    return !!driveTypeOptions.options?.length
        && (
            <AccordionPanel
                eventKey={filterName}
                data-cmp="DriveTypeFilter"
                title={title}
                contentPadding={5}
            >
                {!showFilter && <FilterPlaceholder uniqueKey={filterName} />}
                {showFilter && (
                    <FilterCheckboxes
                        key="driveTypeCheckbox"
                        filter={driveTypeOptions}
                        onOptionChange={onOptionChange}
                        onOptionsClear={onOptionsClear}
                        values={filterValues}
                        errors={filtersErrors}
                        withAccordion={false}
                    />
                )}
            </AccordionPanel>

        );
}

export default DriveTypeFilter;
